import { render, staticRenderFns } from "./JBProposalEmployees.vue?vue&type=template&id=2315d54c"
import script from "./JBProposalEmployees.vue?vue&type=script&lang=js"
export * from "./JBProposalEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports